import React from 'react'

const codriverDetail = () => {
  return (
    <div className='subdetails-wrap'>
        <div className="rightbar-title">
        Codrivers
        </div>

        <div className="subdetail-content">
            <span>Hire Temporary Drivers at your Convenience</span>
        

        <div className="detail-head">Free Will</div>

        <div className="sub-detail">
            <p className='more-sub-detail'>At Sky Cars, you’re provided with a free will upon a condition when you need to or desire to hire a driver for your travel convenience, you can have Codriver on your expenditure.</p>
        </div>

        <div className="detail-head">Trust</div>
        <div className="sub-detail">
            <p className='more-sub-detail'>Our company has no applied module to interfere between your communications and commitments with your Codriver and you have the discretion to select.</p>
        </div>

        <div className="detail-head">Security</div>
        <div className="sub-detail">
            <p className='more-sub-detail'>The Codrivers of your choice must fulfil the eligibility criteria applied for the rental customers in our terms and conditions. We make sure you experience a secured drive.</p>
        </div>

        <div className="detail-head">Versatility</div>
        <div className="sub-detail">
            <p className='more-sub-detail'>We offer this versatility of choosing the Codriver that will make sure your long road journey spends smooth and prevent sudden travel hindrances. </p>
        </div>
        </div>
        
    </div>
  )
}

export default codriverDetail